<template>
  <div class="big returnData">
    <div class="page_title">三方退还数据</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="search-box">
          <!-- 礼品兑换专区 -->
          <div class="item">
            <span>礼品兑换专区</span>
            <div class="item-content">
              <el-select
                v-model="returnDataForm.rule_id"
                placeholder="请选择"
                clearable
                size="small"
                @change="getList"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="item.rule_id"
                  :label="item.jd_name"
                  :value="index"
                ></el-option>
              </el-select>
            </div>
          </div>

          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="returnDataForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 退还时间 -->
          <div class="item">
            <span style="width: 70px">退还时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="returnDataForm.create_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="returnTableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'update_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'parent_order_id'">
                  <div>{{ scope.row[item.prop] }}</div>
                  <div v-if="scope.row['child_order_id']">({{ scope.row["child_order_id"] }})</div>
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      returnDataForm: {
        rule_id: "",
        doctor_name: "",
        times: [],
      },
      options: [],
      tableHeader: [
        {
          label: "医生姓名",
          prop: "doctor_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "医生手机号",
          prop: "phone",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "更新时间",
          prop: "update_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "退还数值",
          prop: "return_bp",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "退款单号",
          prop: "refund_order_id",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "售后服务单号",
          prop: "afs_service_id",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "单号(子单号)",
          prop: "parent_order_id",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "备注",
          prop: "remark",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      returnTableData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getJdShopConfig();
  },
  methods: {
    // 礼品兑换专区
    getJdShopConfig() {
      marketing.getJdShopConfig().then((res) => {
        this.options = res.data.value;
        this.returnDataForm.rule_id = 0;
        this.getList();
      });
    },
    getList() {
      let params = Object.assign({}, this.pagination, this.returnDataForm);
      params = _.omit(params, ["create_time"]);
      let times = this.returnDataForm.create_time;
      params["start_time"] = times ? times[0] : "";
      params["end_time"] = times ? times[1] : "";
      this.tableLoading = true;
      marketing.doctorHeartActivityReturn(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.returnTableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.returnData {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
